import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { MadfarmInput } from "../../../../ui/molecules/input/newInput"
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static"
import TextArea from "../../../../ui/molecules/textArea"
import { ServiceTypeUnitOptions } from "../../../../utils"
import { ServiceTypeUpdate, setSTUpdateAmountPerUnit, setSTUpdateCode, setSTUpdateDescription, setSTUpdateNote, setSTUpdateUnitType } from "../../slice"

interface Props {
    close: () => void
    isAdditional: boolean
}

export function ServiceTypePopupEdit(props: Props) {
    const dispatch = useAppDispatch()
    const serviceTypeState = useAppSelector(state => state.billingAndServiceType)

    useEffect(() => {
        if (serviceTypeState.serviceTypeUpdateStatus === 'successfully') {
            props.close()
        }
    }, [serviceTypeState.serviceTypeUpdateStatus])

    return (
        <div className="px-6 py-5 flex flex-col gap-5">
            <MadfarmInput
                label="Codice"
                placeholder="Specifica codice..."
                value={serviceTypeState.serviceTypeUpdateRequest.code}
                onChangeText={(text) => dispatch(setSTUpdateCode(text))}
            />

            <TextArea
                label="Descrizione"
                placeholder="Specifica descrizione..."
                value={serviceTypeState.serviceTypeUpdateRequest.description}
                onChangeText={(text) => dispatch(setSTUpdateDescription(text))}
            />

            {!props.isAdditional && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <MadfarmStaticSelect
                        label="Unità di Calcolo"
                        placeholder="Seleziona unità..."
                        options={ServiceTypeUnitOptions}
                        value={serviceTypeState.serviceTypeUpdateRequest.unitType}
                        onChange={(value) => {
                            // @ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setSTUpdateUnitType(newValue))
                        }}
                        noOptionsMessage=""
                    />
                    <MadfarmInput
                        label="Importo"
                        placeholder="Specifica importo..."
                        value={serviceTypeState.serviceTypeUpdateRequest.amountPerUnit?.toString()}
                        onChangeText={(text) => dispatch(setSTUpdateAmountPerUnit(text))}
                    />
                </div>
            )}

            <TextArea
                label="Note"
                placeholder="Aggiungi note..."
                value={serviceTypeState.serviceTypeUpdateRequest.note}
                onChangeText={(text) => dispatch(setSTUpdateNote(text))}
            />

            <div className="flex justify-end">
                <ButtonComponent
                    variant="solid"
                    color="orange"
                    size="md"
                    iconPosition="off"
                    label="Salva"
                    onClick={() => dispatch(ServiceTypeUpdate({ body: serviceTypeState.serviceTypeUpdateRequest, id: serviceTypeState.serviceTypeIdToUpdate }))}
                />
            </div>
        </div>
    )
}